import { Link, usePage } from '@inertiajs/react'
import type { SharedProps } from '@/types'

type Section = 'dashboard' | 'leads'

const LINK = 'rounded-lg px-3 py-1.5 text-sm transition-colors'
const ACTIVE = `${LINK} bg-gray-900 font-medium text-white`
const IDLE = `${LINK} text-gray-600 hover:bg-gray-100 hover:text-gray-900`

export default function BackstageNav({ current }: { current: Section }) {
  const { backstage } = usePage<SharedProps>().props

  return (
    <header className="border-b border-gray-200 bg-white">
      <div className="mx-auto flex h-14 max-w-5xl items-center gap-6 px-6">
        <span className="text-sm font-bold tracking-tight text-gray-900">Backstage</span>

        <nav aria-label="Backstage" className="flex items-center gap-1">
          <Link href="/backstage" className={current === 'dashboard' ? ACTIVE : IDLE}>
            Vue d'ensemble
          </Link>
          <Link href="/backstage/leads" className={current === 'leads' ? ACTIVE : IDLE}>
            Leads
          </Link>

          {/* Rails renders these two, not Inertia — hence plain anchors opened in a new tab, so
              coming back doesn't cost a full SPA reload. */}
          <a href="/backstage/jobs" target="_blank" rel="noopener noreferrer" className={IDLE}>
            Jobs <span aria-hidden="true">↗</span>
          </a>

          {/* Null wherever Action Mailer previews are disabled — production included — so the link
              simply isn't rendered there. */}
          {backstage?.mailer_previews_path && (
            <a
              href={backstage.mailer_previews_path}
              target="_blank"
              rel="noopener noreferrer"
              className={IDLE}
            >
              Emails <span aria-hidden="true">↗</span>
            </a>
          )}
        </nav>
      </div>
    </header>
  )
}
